import React, { useState, useEffect } from 'react';
import {
    Paper,
    FormControl,
    TextField,
    Typography,
    FormGroup,
    Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';
import Common from '../Common';
import { withCookies } from 'react-cookie';
const useStyles = makeStyles({
    paper: {
        marginTop: '5px',
        minWidth: 1050,
        textAlign: 'center',
        justifyContent: 'center',
    },
    inputNickName: {
        marginTop: '30px',
        alignItems: 'center',
        justifyContent: 'center'
    },
    attention: {
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: '150px',
        marginTop: '20px'
    },
    categorySelect:{
        margin: '15px 7px 0px 22px',
    },
    conditionLeft: {
        width: '400px',
        fontSize:'20px',
        height: '60px'
    },
    categoryName:{
        borderBottom: 'solid 2px #FFF',
        fontSize:'19px',
        marginRight: '300px',
    },
    title:{
        marginLeft: '30px',
        marginTop: '30px',
        justifyContent: 'center',
        textAlign:'center'
    },
    inputKeyword:{
        fontSize:'20px',
        margin: '20px 0px 10px 0px',
        width: 200
    },
    createButton:{
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '10px',
    },
    table:{
        alignItems: 'center',
        justifyContent: 'center',
    },
    categoryLabel: {
        textAlign: 'left',
        fontSize:'20px',
        margin: '0px 0px 10px 200px',
        //  width: 200
    },
    noteLabel: {
        textAlign: 'left',
        fontSize:'15px',
        margin: '0px 0px 10px 400px',
        width: 500
    },
    inputNote:{
        fontSize:'20px',
        margin: '20px 0px 10px 30px',
    },
    note:{
        width: '400px',
        fontSize:'20px',
    },
    paging: {
        marginTop: '20px',
        marginBottom: '20px'
    },
    created:{
        alignItems: 'center',
        justifyContent: 'center',
        marginRight:'675px'
    },
    createdDisplay:{
        fontSize:'18px',
        alignItems: 'left',
        justifyContent: 'left',
    },
    left:{
        display: 'inline-block',
    },
    marginAuto:{
        margin: '0px 50px 10px 5px'
    }
});
const Notification = withCookies((props) => {
    const classes = useStyles();
    const [ initialAddress, setInitialAddress] = useState('');
    const [mail, setMail] = useState('');
    const [update, setUpdata]= useState(false);
    const [activeFlag, setActiveFlag] = useState(false);
    const [validator, setValidator] = useState(false);

    const { cookies } = props;
    const commonNameObj = cookies.get('COMMON_NAME_OBJ');
    document.title = commonNameObj !== undefined ? commonNameObj.CHAT_NAME : '1対1チャット';

    //-----------------------------------------------------------------
    //              ページに格納するデータの取得
    //-----------------------------------------------------------------
    function getSettingMailAddress() {

        if(mail === ''){
            const token = cookies.get('token');
            const jichitaiToken = cookies.get('x-jichitai-token');
            const jichitaiId = cookies.get('x-jichitai-jichitaiid');
            const supportedPersonId = cookies.get('supportedPersonId');

            axios.get(
            `${Common.apiServerUrl()}/api/supporter/mail`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'x-suppportcenter-token': token,
                    'x-jichitai-jichitaiid': jichitaiId,
                    'x-jichitai-token': jichitaiToken,
                },
                params: {
                    supportedPersonId
                }
            })
            .then(Common.handleErrors)
            .then((supporterData) => {
                if (supporterData.success) {
                    if(supporterData.mail === '' || supporterData.mail === undefined){
                        setActiveFlag(false);
                    }
                    else{
                        setInitialAddress(supporterData.mail);
                        setMail(supporterData.mail);
                    }
                } else {
                    alert(`code : [${supporterData.code}]\nmessage : ${supporterData.error_usermsg}`);
                }
            })
            .catch((err) => {
                console.log(err);
                if (Object.keys(err).indexOf('data') !== -1) {
                    alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
                } else {
                    alert('code : [getResponsibleKubun]\nmessage : エラーが発生しました。サポートに連絡してください。');
                }
            });
        }
    }

    useEffect(() => {
        if(cookies.get('supporterFullName') === undefined || cookies.get('supporterFullName') === ''){
            window.location.href = '/';
        }
        else if(mail === '') getSettingMailAddress();
    },[]);

    window.history.pushState(null, '', window.location.href);

    //入力されたメールアドレスをkintoneに保存する
    function saveMail() {
        const confirm = window.confirm('メールアドレスを変更しますか？');
        if(confirm){
            axios.post(
                `${Common.apiServerUrl()}/api/supporter/mail`,
                {
                    mail,
                    supportedPersonId: cookies.get('supportedPersonId')
                },
                {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + cookies.get('access_token'),
                        'x-suppportcenter-token': cookies.get('token'),
                        'x-jichitai-jichitaiid': cookies.get('x-jichitai-jichitaiid'),
                        'x-jichitai-token': cookies.get('x-jichitai-token'),
                    },
                    data: {},
                }
            )
            .then(Common.handleErrors)
            .then((response) => {
                if (response.success) {
                    window.alert('メールアドレスを変更しました。');
                    setUpdata(update ? false : true);
                    window.location.href = '/setting';
                    return;
                } else {
                    window.alert(`code : [${response.type}]\nmessage : ${response.message}`);
                }
            })
            .catch((err) => {
                console.error('Notification.js saveMail: post err:' + err);
            });
        }
    }

    function changeMail(inputAddress){
        /*メールアドレスのパターン 正規表現*/
        const pattern = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/;
        if(inputAddress === '' || pattern.test(inputAddress)){
            setValidator(false);
            if(inputAddress === initialAddress) setActiveFlag(false);
            else setActiveFlag(true);
        }
        else{
            setValidator(true);
            setActiveFlag(false);
        }
        setMail(inputAddress);
    }


    return (
        <React.Fragment>
            <div elevation={3} className={classes.paper} >
                <div className={classes.left}>
                    <Typography className={classes.title} variant="h4" component="p">
                        {'通知先設定'}
                    </Typography>
                    <Paper elevation={2} variant="outlined" className={classes.paper}></Paper>
                    <FormGroup className={classes.inputNickName} row>
                        <Typography variant="body1" className={classes.inputKeyword}>
                            {'メールアドレス：'}
                        </Typography>
                        <div className={classes.marginAuto}>
                            <React.Fragment>
                                <FormControl className={classes.categorySelect}>
                                    <TextField
                                        error={validator}
                                        id="outlined-basic"
                                        variant="outlined"
                                        className={classes.conditionLeft}
                                        margin="normal"
                                        value={mail}
                                        helperText={validator ? '正しいメールアドレスを入力してください。' : ''}
                                        onChange={(event) => changeMail(event.target.value)}
                                    />
                                </FormControl>
                            </React.Fragment>
                        </div>
                        <Button
                            className={classes.createButton}
                            variant="contained"
                            onClick={() => saveMail()}
                            disabled={!activeFlag}
                            color="primary"
                        >
                            {'保存'}
                        </Button>
                    </FormGroup>
                    <FormGroup className={classes.attention} row>
                        <Typography variant="body5" className={classes.categoryLabel}>
                            {'※上記のメールアドレスに新着通知のメッセージが送信されます。'}
                        </Typography>
                    </FormGroup>
                </div>
            </div>
        </React.Fragment>
    );
});

export default withCookies(Notification);
